module.exports = __webpack_public_path__ + "media/images/thumb_llamaloca-a3ddcc0136c4d621838e840dbb3ba9c4.png";